import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { MarchiService } from 'my-lib-sanfelici';
import { Marchio } from 'my-lib-sanfelici';



@Component({
  selector: 'app-marchi-create',
  templateUrl: './marchi-create.component.html',
  styleUrls: ['./marchi-create.component.css']
})
export class MarchiCreateComponent implements OnInit {
marchio: Marchio;
id: string;
  constructor(
    private router: Router,
    private marchiservice: MarchiService,
    private afs: AngularFirestore
  ) { }
save() {
this.marchiservice.create( this.marchio).then(() => {
  this.router.navigate(['/marchi']);
});
}
  ngOnInit() {
    this.marchio = {image_id: null, id:null,
      Marca: null, Attivo: true, slug: null};
  }

}
